import StartListItem from "./StartListItem";
import {match} from "react-router";
import ContestFilteredContentItem from "./ContestFilteredContentItem";

export default class StartList {
  private data: StartListItem[] = [];

  constructor(items?: StartListItem[] | undefined) {
    if (items) {
      items.forEach(i => this.data.push(i));
      this.data.sort((i1, i2) => {
        const x = i1.startNumber;
        const y = i2.startNumber;
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    }
  }

  add(item: StartListItem) {
    this.data.push(item);
  }

  map<T>(mapFunction: (arg: StartListItem) => T): T[] {
    return Array.from(this.data.values()).map(mapFunction);
  }

  sort(sortFunction: (arg1: StartListItem, arg2: StartListItem) => number): StartListItem[] {
    return Array.from(this.data.values()).sort(sortFunction);
  }

  filter<T>(filterFunction: (arg: StartListItem) => boolean): StartList {
    return new StartList(Array.from(this.data.values()).filter(filterFunction));
  }

  forEach(forEachFunction: (arg: StartListItem, index: number) => void): void {
    return Array.from(this.data.values()).forEach(forEachFunction);
  }

  filterContent(searchValue: string | undefined): StartList {
    if (!searchValue || searchValue.length === 0) {
      return this;
    }
    const searches = searchValue ? searchValue.toLowerCase().split(" ") : [];
    return this.filter((i: StartListItem) => {
        const horseMatch: boolean = i.horse !== undefined && this.matches(i.horse, searches);
        const riderMatch: boolean = i.rider !== undefined && this.matches(i.rider, searches);
        const clubNameMatch: boolean = i.clubName !== undefined && this.matches(i.clubName, searches);
        let result: boolean;
        if (!i.horse && !i.rider) {
          result = false;
        } else if (!i.horse) {
          result = riderMatch;
        } else if (!i.rider) {
          result = horseMatch
        } else if (!i.clubName) {
          result = clubNameMatch
        } else {
          result = horseMatch || riderMatch || clubNameMatch;
        }
        return result;
      }
    )
  }

  private matches(value:string, searches: string[]): boolean {
    let matches = true;
    searches.forEach(search => {
      if(value.toLowerCase().indexOf(search) === -1){
        matches = false;
      }
    });
    return matches;
  }
}
